module.exports = __webpack_public_path__ + "img/banner-wingo.d4ab8f5b.png";